export default "__VITE_ASSET__DNTYrfd1__"